import { IPublicationResponse } from "../../../model/base/response/publication-response";
import { ICategoryPublicationResponse } from "../../../model/base/response/category-publication-response";
import { ISubcategoryPublicationResponse } from "../../../model/base/response/subcategory-publication-response";
import { IPublishingVehicleResponse } from "../../../model/base/response/publishing-vehicle-response";
import { Pagination } from "../../../model/paginatiion";

export enum ACTION_TYPES {
    setPublications = 'setPublications',
    clearPublications = 'clearPublications',
    setCategories = 'setCategories',
    setSubcategories = 'setSubcategories',
    setPublishingVehicles = 'setPublishingVehicles',
}

export interface IPublicationsState {
    publications?: Pagination<IPublicationResponse>;
    categories?: ICategoryPublicationResponse[];
    subcategories?: ISubcategoryPublicationResponse[];
    publishingVehicles?: IPublishingVehicleResponse[];
}

export interface IPublicationsAction {
    type: ACTION_TYPES;
    payload?: any;
}

export const initialState: IPublicationsState = {
    publications: undefined,
    categories: undefined,
    subcategories: undefined,
    publishingVehicles: undefined,
};

export const publicationsReducer = (state: IPublicationsState, action: IPublicationsAction): IPublicationsState => {
    switch (action.type) {
        case ACTION_TYPES.setPublications:
            return { ...state, publications: action.payload };
        case ACTION_TYPES.clearPublications:
            return { ...state, publications: undefined };
        case ACTION_TYPES.setCategories:
            return { ...state, categories: action.payload };
        case ACTION_TYPES.setSubcategories:
            return { ...state, subcategories: action.payload };
        case ACTION_TYPES.setPublishingVehicles:
            return { ...state, publishingVehicles: action.payload };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
